import { LAT_LON_FALLBACK } from './constants';
import { LatLon } from './types';

export const LOCATION_PERMISSION_UNDETERMINED = 0;
export const LOCATION_PERMISSION_IN_USE = 1;
export const LOCATION_PERMISSION_ALWAYS = 2; // background location for mobile devices
export const LOCATION_PERMISSION_NEVER = 3;

export function locationPermissionFromDenied(denied: boolean | null) {
  if (denied === true) {
    return LOCATION_PERMISSION_NEVER;
  } else if (denied === false) {
    return LOCATION_PERMISSION_IN_USE;
  }
  return LOCATION_PERMISSION_UNDETERMINED;
}

export const deg2rad = (deg: number): number => deg * (Math.PI / 180);
export const ONE_MILES_IN_M = 1609; // 1 mile
export const DISTANCE_FILTER = ONE_MILES_IN_M;

// http://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
export const getDistance = (pos1: LatLon, pos2: LatLon) => {
  const lat1 = pos1.lat;
  const lon1 = pos1.lon;
  const lat2 = pos2.lat;
  const lon2 = pos2.lon;

  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c * 1000; // Distance in m
  return d;
};

export const normalizeLatLon = (location: {
  lat: number | undefined;
  lon: number | undefined;
}): LatLon => {
  if (!location.lat || !location.lon) {
    return LAT_LON_FALLBACK;
  }

  return location as LatLon;
};
